import React from "react";

const getFileIcon = (attachment) => {
    const name = String(attachment?.originalFileName || "").toLowerCase();
    const mime = String(attachment?.mimeType || "").toLowerCase();
    if (mime.includes("pdf") || name.endsWith(".pdf")) return "PDF";
    if (mime.includes("image") || /\.(png|jpe?g)$/.test(name)) return "IMG";
    if (name.endsWith(".doc") || name.endsWith(".docx")) return "DOC";
    if (name.endsWith(".xlsx")) return "XLS";
    if (name.endsWith(".txt")) return "TXT";
    return "FILE";
};

const formatSize = (sizeBytes) => {
    const value = Number(sizeBytes || 0);
    if (value < 1024) return `${value} o`;
    if (value < 1024 * 1024) return `${Math.round(value / 1024)} Ko`;
    return `${(value / 1024 / 1024).toFixed(1)} Mo`;
};

export default function ContentQuestionAttachments({ attachments = [], onDownload, onDelete, disabled }) {
    if (!attachments.length) return null;

    return (
        <div className="cq-attachments">
            {attachments.map((attachment) => (
                <div key={attachment.id} className="cq-attachment">
                    <span className="cq-attachment-icon">{getFileIcon(attachment)}</span>
                    <button
                        type="button"
                        className="cq-attachment-name"
                        onClick={() => onDownload?.(attachment)}
                        disabled={disabled}
                    >
                        {attachment.originalFileName}
                    </button>
                    <span className="cq-attachment-size">{formatSize(attachment.sizeBytes)}</span>
                    {attachment.canDelete ? (
                        <button
                            type="button"
                            className="cq-attachment-delete"
                            onClick={() => onDelete?.(attachment)}
                            disabled={disabled}
                        >
                            Supprimer
                        </button>
                    ) : null}
                </div>
            ))}
        </div>
    );
}
